export default `
precision highp float;

attribute vec2 aVertexPosition;
attribute vec2 uv;

//Pixi provided
uniform mat3 translationMatrix;
uniform mat3 projectionMatrix;

varying vec2 vUv;
varying vec2 vPosition;

void main() {
	vec2 position = aVertexPosition;
	vPosition = position;
	vUv = uv;
	gl_Position = vec4((projectionMatrix * translationMatrix * vec3(position, 1.0)).xy, 0.0, 1.0);
}
`